import { render, staticRenderFns } from "./VehicleEditDialogListDetails.vue?vue&type=template&id=0df5199c&"
import script from "./VehicleEditDialogListDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleEditDialogListDetails.vue?vue&type=script&lang=js&"
import style0 from "./VehicleEditDialogListDetails.vue?vue&type=style&index=0&id=0df5199c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports